import { createPinia, getActivePinia } from "pinia";
import { defineStore } from "pinia";
import businessStore from "./business";
import ChatDb from "@/utils/chat/idb";

const modules = import.meta.glob("./modules/*.js", { eager: true });

export { businessStore };

export const useCommonStore = defineStore("commonStore", {
    state: () => ({
        db: null,
    }),
    actions: {
        initDb() {
            if (!this.db) {
                this.db = new ChatDb();
            }
        },
        setDbItem(key, value) {
            this.initDb();
            return this.db.ready().then(() => this.db.setItem(key, value));
        },
        getDbItem(key) {
            this.initDb();
            return this.db.ready().then(() => this.db.getItem(key));
        },
        removeDbItem(key) {
            this.initDb();
            return this.db.ready().then(() => this.db.removeItem(key));
        },
    },
});

export function ensurePinia(app) {
    let pinia = typeof getActivePinia === "function" ? getActivePinia() : null;

    if (!pinia) {
        pinia = createPinia();
    }

    if (app && app.use) {
        app.use(pinia);
    }

    return pinia;
}

export async function initStores(pinia) {
    await Promise.all(
        Object.values(modules).map((mod) => {
            if (typeof mod.initStore === "function") {
                return mod.initStore(pinia);
            }
            return Promise.resolve();
        })
    );
}
